export const SET_MEMO_LIST = "SET_MEMO_LIST";

export const GET_MEMO_LIST = "GET_MEMO_LIST";

export const DELETE_MEMO = "DELETE_MEMO";
